export default __webpack_public_path__ + "static/media/AtomsAndCompounds _22.6a7d2d43.png";